import { onUnmounted } from 'intact-vue-next';
export function useKeyboard(options) {
  var locked = false;
  var onKeydown = function onKeydown(e) {
    if (locked) return;
    switch (e.keyCode) {
      // down
      case 40:
        options.down(e);
        break;
      // up
      case 38:
        options.up(e);
        break;
      // right
      case 39:
        options.right(e);
        break;
      // left
      case 37:
        options.left(e);
        break;
      // enter
      case 13:
        options.enter(e);
        break;
      default:
        options.default && options.default(e);
        break;
    }
  };
  var removeEventListener = function removeEventListener() {
    document.removeEventListener('keydown', onKeydown);
  };
  var addEventListener = function addEventListener() {
    document.addEventListener('keydown', onKeydown);
  };
  onUnmounted(removeEventListener);
  return [addEventListener, removeEventListener, function (v) {
    return locked = v;
  }];
}